import React, { useState } from 'react';
import { FaClock, FaCalendarAlt } from 'react-icons/fa';
import ProfileModal from './../Layout/Components/ProfileModal';
import { toJalaliDate } from '../utils/dateUtils';

const TaskAssignedRow = ({ title, description, deadline, assignee_name }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const deadlineDate = toJalaliDate(deadline);
  const deadlineTime = deadline ? new Date(deadline).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <>
      <div className="bg-white p-5 rounded-3xl border border-slate-100 shadow-sm hover:shadow-md transition-all flex items-center gap-4">
        <div className="flex-1">
          <h3 className="font-bold text-slate-800 text-sm mb-2">{title}</h3>
          <p className="text-xs text-slate-500 mb-4 line-clamp-2">{description}</p>
          <div className="flex items-center gap-4 text-[10px] text-slate-400 font-medium">
            <div className="flex items-center gap-1"><FaCalendarAlt /> {deadlineDate || 'بدون مهلت'}</div>
            {deadlineTime && <div className="flex items-center gap-1"><FaClock /> {deadlineTime}</div>}
          </div>
        </div>

        <div
          onClick={() => setIsProfileOpen(true)}
          className="flex flex-col items-center gap-2 p-3 bg-slate-50 rounded-2xl cursor-pointer hover:bg-indigo-50 transition-colors w-24 shrink-0"
        >
          <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center text-sm font-bold text-indigo-600 border-2 border-white shadow-sm">
            {assignee_name?.charAt(0) || "؟"}
          </div>
          <span className="text-[10px] font-bold text-slate-700 text-center leading-tight">
            {assignee_name || "نامشخص"}
          </span>
        </div>
      </div>

      <ProfileModal
        user={{ name: assignee_name }}
        isOpen={isProfileOpen}
        onClose={() => setIsProfileOpen(false)}
        canEdit={false}
      />
    </>
  );
};

export default TaskAssignedRow;